export default "__VITE_ASSET__DXDmc8G5__"